module.exports = __webpack_public_path__ + "img/snapchat.c1c57ca8.svg";